import {
  ActivityConfiguration,
  AddConfigDTO,
  Config_Socket_DTO,
  Delete_Socket_DTO,
  ResidentActivityType,
  SendActivityDTO,
  skipActivityDTO,
} from ".";
import { ReminderAction } from "../alerts";
import {
  DAILY_PLAN,
  IAddBulkPlanConfigFailure,
  IAddBulkPlanConfigRequest,
  IAddBulkPlanConfigSuccess,
  IAddPlanConfigFailure,
  IAddPlanConfigRequest,
  IAddPlanConfigSuccess,
  IDeleteBulkPlanConfigFailure,
  IDeleteBulkPlanConfigRequest,
  IDeleteBulkPlanConfigSuccess,
  IDeletePlanConfigFailure,
  IDeletePlanConfigRequest,
  IDeletePlanConfigSuccess,
  IEditPlanConfigFailure,
  IEditPlanConfigRequest,
  IEditPlanConfigSuccess,
  IGetActivitiesFeedbackOptionsFailure,
  IGetActivitiesFeedbackOptionsRequest,
  IGetActivitiesFeedbackOptionsSuccess,
  IGetActivitiesSkipOptionsFailure,
  IGetActivitiesSkipOptionsRequest,
  IGetActivitiesSkipOptionsSuccess,
  IGetActivityBySocket,
  IGetCongigAddedBySocket,
  IGetCongigDeletedBySocket,
  IGetCongigUpdatedBySocket,
  IGetResidentActivitiesFailure,
  IGetResidentActivitiesRequest,
  IGetResidentActivitiesSuccess,
  IGetResidentPresencesFailure,
  IGetResidentPresencesRequest,
  IGetResidentPresencesSuccess,
  IGetResidentsActivitiesFailure,
  IGetResidentsActivitiesRequest,
  IGetResidentsActivitiesSuccess,
  IGetResidentsConfigurationFailure,
  IGetResidentsConfigurationRequest,
  IGetResidentsConfigurationSuccess,
  IGetResidentsPresencesFailure,
  IGetResidentsPresencesRequest,
  IGetResidentsPresencesSuccess,
  ISendResidentActivityFailure,
  ISendResidentActivityRequest,
  ISendResidentActivitySuccess,
  ISkipActivityFailure,
  ISkipActivityRequest,
  ISkipActivitySuccess,
  IUnSkipActivityFailure,
  IUnSkipActivityRequest,
  IUnSkipActivitySuccess,
} from "./types";

export function addDailyPlanConfig(
  residentId: string,
  item: ActivityConfiguration
): IAddPlanConfigRequest {
  return {
    type: DAILY_PLAN.ADD_PLAN_CONFIG_REQUEST,
    payload: { residentId, item },
  };
}

export function addDailyPlanConfigSussess(
  residentId: string,
  item: ActivityConfiguration
): IAddPlanConfigSuccess {
  return {
    type: DAILY_PLAN.ADD_PLAN_CONFIG_SUCCESS,
    payload: { residentId, item },
  };
}

export function addDailyPlanConfigFailure(value: any): IAddPlanConfigFailure {
  return { type: DAILY_PLAN.ADD_PLAN_CONFIG_FAILURE, payload: { value } };
}
export function addBulkDailyPlanConfig(
  dto: AddConfigDTO
): IAddBulkPlanConfigRequest {
  return { type: DAILY_PLAN.BULK_ADD_PLAN_CONFIG_REQUEST, payload: dto };
}

export function addBulkDailyPlanConfigSussess(
  dto: AddConfigDTO
): IAddBulkPlanConfigSuccess {
  return { type: DAILY_PLAN.BULK_ADD_PLAN_CONFIG_SUCCESS, payload: dto };
}

export function addBulkDailyPlanConfigFailure(
  value: any
): IAddBulkPlanConfigFailure {
  return { type: DAILY_PLAN.BULK_ADD_PLAN_CONFIG_FAILURE, payload: { value } };
}
export function editDailyPlanConfig(
  residentId: string,
  item: ActivityConfiguration
): IEditPlanConfigRequest {
  return {
    type: DAILY_PLAN.EDIT_PLAN_CONFIG_REQUEST,
    payload: { residentId, item },
  };
}

export function editDailyPlanConfigSussess(
  residentId: string,
  item: ActivityConfiguration
): IEditPlanConfigSuccess {
  return {
    type: DAILY_PLAN.EDIT_PLAN_CONFIG_SUCCESS,
    payload: { residentId, item },
  };
}

export function editDailyPlanConfigFailure(value: any): IEditPlanConfigFailure {
  return { type: DAILY_PLAN.EDIT_PLAN_CONFIG_FAILURE, payload: { value } };
}

export function deleteDailyPlanConfig(
  residentId: string,
  itemType: ResidentActivityType
): IDeletePlanConfigRequest {
  return {
    type: DAILY_PLAN.DELETE_PLAN_CONFIG_REQUEST,
    payload: { residentId, itemType },
  };
}

export function deleteDailyPlanConfigSussess(
  residentId: string,
  itemType: ResidentActivityType
): IDeletePlanConfigSuccess {
  return {
    type: DAILY_PLAN.DELETE_PLAN_CONFIG_SUCCESS,
    payload: { residentId, itemType },
  };
}

export function deleteDailyPlanConfigFailure(
  value: any
): IDeletePlanConfigFailure {
  return { type: DAILY_PLAN.DELETE_PLAN_CONFIG_FAILURE, payload: { value } };
}
export function deleteBulkDailyPlanConfig(
  residentIds: string[],
  activityType: ResidentActivityType
): IDeleteBulkPlanConfigRequest {
  return {
    type: DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_REQUEST,
    payload: { residentIds, activityType },
  };
}

export function deleteBulkDailyPlanConfigSussess(
  residentIds: string[],
  activityType: ResidentActivityType
): IDeleteBulkPlanConfigSuccess {
  return {
    type: DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_SUCCESS,
    payload: { residentIds, activityType },
  };
}

export function deleteBulkDailyPlanConfigFailure(
  value: any
): IDeleteBulkPlanConfigFailure {
  return {
    type: DAILY_PLAN.BULK_DELETE_PLAN_CONFIG_FAILURE,
    payload: { value },
  };
}

export function getResidentActivities(
  startDate: string,
  endDate: string
): IGetResidentsActivitiesRequest {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_REQUEST,
    payload: { startDate, endDate },
  };
}

export function getResidentActivitiesSussess(
  startDate: string,
  endDate: string,
  data: any[]
): IGetResidentsActivitiesSuccess {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_SUCCESS,
    payload: { startDate, endDate, data },
  };
}

export function getResidentActivitiesFailure(
  value: any
): IGetResidentsActivitiesFailure {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_FAILURE,
    payload: { value },
  };
}

export function getOneResidentActivities(
  startDate: string,
  endDate: string,
  residentId: string
): IGetResidentActivitiesRequest {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_REQUEST,
    payload: { startDate, endDate, residentId },
  };
}

export function getOneResidentActivitiesSussess(
  startDate: string,
  endDate: string,
  data: any[],
  residentId: string
): IGetResidentActivitiesSuccess {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_SUCCESS,
    payload: { startDate, endDate, data, residentId },
  };
}

export function getOneResidentActivitiesFailure(
  value: any
): IGetResidentActivitiesFailure {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_FAILURE,
    payload: { value },
  };
}

export function getResidentConfiguration(): IGetResidentsConfigurationRequest {
  return { type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST };
}

export function getResidentConfigurationSussess(
  data: any[]
): IGetResidentsConfigurationSuccess {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_SUCCESS,
    payload: data,
  };
}

export function getResidentConfigurationFailure(
  value: any
): IGetResidentsConfigurationFailure {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_FAILURE,
    payload: { value },
  };
}

export function sendResidentActivity(
  dto: SendActivityDTO
): ISendResidentActivityRequest {
  return { type: DAILY_PLAN.SEND_RESIDENT_ACTIVITY_REQUEST, payload: dto };
}

export function sendResidentActivitySussess(
  dto: SendActivityDTO
): ISendResidentActivitySuccess {
  return { type: DAILY_PLAN.SEND_RESIDENT_ACTIVITY_SUCCESS, payload: dto };
}

export function sendResidentActivityFailure(
  value: any
): ISendResidentActivityFailure {
  return {
    type: DAILY_PLAN.SEND_RESIDENT_ACTIVITY_FAILURE,
    payload: { value },
  };
}

export function skipActivity(dto: skipActivityDTO): ISkipActivityRequest {
  return { type: DAILY_PLAN.SKIP_ACTIVITY_REQUEST, payload: dto };
}

export function skipActivitySussess(value: any): ISkipActivitySuccess {
  return { type: DAILY_PLAN.SKIP_ACTIVITY_SUCCESS, payload: value };
}

export function skipActivityFailure(value: any): ISkipActivityFailure {
  return { type: DAILY_PLAN.SKIP_ACTIVITY_FAILURE, payload: value };
}

export function unskipActivity(dto: skipActivityDTO): IUnSkipActivityRequest {
  return { type: DAILY_PLAN.UNSKIP_ACTIVITY_REQUEST, payload: dto };
}

export function unskipActivitySussess(value: any): IUnSkipActivitySuccess {
  return { type: DAILY_PLAN.UNSKIP_ACTIVITY_SUCCESS, payload: value };
}

export function unskipActivityFailure(value: any): IUnSkipActivityFailure {
  return { type: DAILY_PLAN.UNSKIP_ACTIVITY_FAILURE, payload: value };
}

export function getActivityBySocket(
  value: ReminderAction
): IGetActivityBySocket {
  return { type: DAILY_PLAN.GET_ACTIVITY_BY_SOCKET, payload: value };
}
export function getActivityConfigAddedBySocket(
  value: Config_Socket_DTO
): IGetCongigAddedBySocket {
  return {
    type: DAILY_PLAN.GET_ACTIVITY_CONFIG_ADDED_BY_SOCKET,
    payload: value,
  };
}
export function getActivityConfigDeletedBySocket(
  value: Delete_Socket_DTO
): IGetCongigDeletedBySocket {
  return {
    type: DAILY_PLAN.GET_ACTIVITY_CONFIG_DELETED_BY_SOCKET,
    payload: value,
  };
}
export function getActivityConfigUpdatedBySocket(
  value: Config_Socket_DTO
): IGetCongigUpdatedBySocket {
  return {
    type: DAILY_PLAN.GET_ACTIVITY_CONFIG_UPDATED_BY_SOCKET,
    payload: value,
  };
}

export function getActivitiesFeedback(): IGetActivitiesFeedbackOptionsRequest {
  return { type: DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_REQUEST };
}

export function getActivitiesFeedbackSussess(
  value: any
): IGetActivitiesFeedbackOptionsSuccess {
  return {
    type: DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_SUCCESS,
    payload: value,
  };
}

export function getActivitiesFeedbackFailure(
  value: any
): IGetActivitiesFeedbackOptionsFailure {
  return {
    type: DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_FAILURE,
    payload: value,
  };
}

export function getActivitiesSkip(): IGetActivitiesSkipOptionsRequest {
  return { type: DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_REQUEST };
}

export function getActivitiesSkipSussess(
  value: any
): IGetActivitiesSkipOptionsSuccess {
  return {
    type: DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_SUCCESS,
    payload: value,
  };
}

export function getActivitiesSkipFailure(
  value: any
): IGetActivitiesSkipOptionsFailure {
  return {
    type: DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_FAILURE,
    payload: value,
  };
}

export function getResidentPresences(
  startDate: string,
  endDate: string
): IGetResidentsPresencesRequest {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_PRESENCES_REQUEST,
    payload: { startDate, endDate },
  };
}

export function getResidentPresencesSussess(
  startDate: string,
  endDate: string,
  data: any[]
): IGetResidentsPresencesSuccess {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_PRESENCES_SUCCESS,
    payload: { startDate, endDate, data },
  };
}

export function getResidentPresencesFailure(
  value: any
): IGetResidentsPresencesFailure {
  return {
    type: DAILY_PLAN.GET_RESIDENTS_PRESENCES_FAILURE,
    payload: { value },
  };
}

export function getOneResidentPresences(
  startDate: string,
  endDate: string,
  residentId: string
): IGetResidentPresencesRequest {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_REQUEST,
    payload: { startDate, endDate, residentId },
  };
}

export function getOneResidentPresencesSussess(
  startDate: string,
  endDate: string,
  data: any[],
  residentId: string
): IGetResidentPresencesSuccess {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_SUCCESS,
    payload: { startDate, endDate, data, residentId },
  };
}

export function getOneResidentPresencesFailure(
  value: any
): IGetResidentPresencesFailure {
  return {
    type: DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_FAILURE,
    payload: { value },
  };
}
